module.exports = __webpack_public_path__ + "img/faq-page-bg.d8e6a073.png";